<template>
  <div v-if="isAuthenticated" class="mobile-bottom-nav md:hidden">
    <nav class="bottom-nav">
      <router-link 
        v-for="item in navItems" 
        :key="item.name"
        :to="item.path" 
        class="nav-item"
        :class="{ active: isActive(item.path) }"
      >
        <div class="nav-icon-wrapper">
          <fa-icon :icon="item.icon" class="nav-icon" />
          <span v-if="item.badge && item.badgeCount > 0" class="badge">
            {{ item.badgeCount > 99 ? '99+' : item.badgeCount }}
          </span>
        </div>
        <span class="nav-label">{{ item.label }}</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomNav',
  data() {
    return {
      navItems: [
        {
          name: 'dashboard',
          path: '/',
          icon: ['fas', 'home'],
          label: 'Home',
          badge: false,
        },
        {
          name: 'reports',
          path: '/reports',
          icon: ['fas', 'chart-line'],
          label: 'Reports',
          badge: false,
        },
        {
          name: 'tags',
          path: '/tags',
          icon: ['fas', 'tags'],
          label: 'Tags',
          badge: false,
        },
        {
          name: 'notifications',
          path: '/notifications',
          icon: ['fas', 'bell'],
          label: 'Alerts',
          badge: true,
          badgeCount: 0,
        },
        {
          name: 'profile',
          path: '/profile',
          icon: ['fas', 'user'],
          label: 'Profile',
          badge: false,
        },
      ],
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    unreadNotifications() {
      return this.$store.getters.unreadNotificationsCount || 0;
    },
  },
  watch: {
    unreadNotifications(newCount) {
      const notifItem = this.navItems.find(item => item.name === 'notifications');
      if (notifItem) {
        notifItem.badgeCount = newCount;
      }
    },
  },
  mounted() {
    // Initialize badge count from store
    const notifItem = this.navItems.find(item => item.name === 'notifications');
    if (notifItem) {
      notifItem.badgeCount = this.unreadNotifications;
    }
  },
  methods: {
    isActive(path) {
      if (path === '/') {
        return this.$route.path === '/';
      }
      return this.$route.path.startsWith(path);
    },
  },
};
</script>

<style scoped>
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding-bottom: env(safe-area-inset-bottom);
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.bottom-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 64px;
  max-width: 100%;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #6b7280;
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 8px 4px;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.nav-item:hover,
.nav-item:active {
  color: #1e40af;
  background-color: #eff6ff;
}

.nav-item.active {
  color: #1e40af;
}

.nav-item.active .nav-icon-wrapper {
  transform: translateY(-2px);
}

.nav-icon-wrapper {
  position: relative;
  transition: transform 0.2s ease;
}

.nav-icon {
  font-size: 20px;
  margin-bottom: 4px;
  pointer-events: none; /* ensure tap hits the router-link on iOS Safari */
}

.nav-label {
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}

.badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background: #ef4444;
  color: white;
  border-radius: 10px;
  padding: 2px 5px;
  font-size: 9px;
  font-weight: bold;
  min-width: 18px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  pointer-events: none; /* prevent badge from swallowing taps on Safari */
}

/* Add padding to the main content to prevent overlap */
@media (max-width: 768px) {
  .content {
    padding-bottom: 80px !important;
  }
}
</style>

<style>
/* Dark mode support - non-scoped */
html.dark .mobile-bottom-nav {
  background: #1f2937 !important;
  border-top-color: #374151 !important;
}

html.dark .mobile-bottom-nav .nav-item {
  color: #9ca3af !important;
}

html.dark .mobile-bottom-nav .nav-item:hover,
html.dark .mobile-bottom-nav .nav-item:active {
  color: #60a5fa !important;
  background-color: #1e3a5f !important;
}

html.dark .mobile-bottom-nav .nav-item.active {
  color: #60a5fa !important;
}
</style>
